var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherLightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  fill: "none",
  viewBox: "0 0 7.498 13.931"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M7.408 3.667a.33.33 0 0 1 .059.367l-4.52 9.686a.4.4 0 0 1-.47.193c-.183-.06-.292-.235-.25-.411l1.65-6.764-3.4.846a.5.5 0 0 1-.1.008.4.4 0 0 1-.26-.092.33.33 0 0 1-.108-.326L1.692.268A.37.37 0 0 1 2.059 0h2.747c.21 0 .376.16.376.353a.34.34 0 0 1-.042.15L3.71 4.378l3.314-.82a.4.4 0 0 1 .1-.017c.109 0 .21.05.284.126",
  clipRule: "evenodd"
})));
export default SvgWeatherLightning;